<template>
  <div class="cardContent__container">
    <div
      v-for="(item, index) in data.imageCardContent"
      :key="index"
      class="cardContent__wrapper"
      :class="item.contentAlignment.value"
      :style="
        item.contentTextColour ? { '--comp-contentTextColour-color': item.contentTextColour } : {}
      "
    >
      <div class="cardContent__image">
        <img
          v-if="item.cardImageUrl"
          class="lazyload"
          :data-src="item.cardImageUrl"
          :alt="item.cardImageAlt"
          :src="transparentPixel"
        />
      </div>
      <div v-if="item.preTitle" class="cardContent_preTitle">{{ item.preTitle }}</div>
      <h3 v-if="item.title" class="cardContent_title">{{ item.title }}</h3>
    </div>
  </div>
</template>
<script>
export default {
  name: 'enhanced-editorial-threecard',
  props: {
    data: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data() {
    return {
      transparentPixel:
        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    };
  },
};
</script>
